/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";
import "react-toggle/style.css"

/* Helpers, constants, custom methods, internal libraries */
/* Components */
import UCCheckbox from "../uccheckbox"
/* Styles */
import styles from "./styles.js"

const NotificationPreference = ({title, description, checkboxChange, checked}) => {

  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <div className={classes.notificationContainer}>
        <div>            
          <div className={classes.title}>{title}</div>
          <div className={classes.description}>{description}</div>
        </div>
        <UCCheckbox
          checked={checked}
          onChange={checkboxChange}
        />
    </div>
  )
}

export default NotificationPreference;
